import React, { useState, useEffect } from "react";

import axios from "axios";
import { server } from "../../utills/utils";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions/actionTypes";
import Virat from "../../assets/virat.png";
import Pin from "../../assets/pin.svg";
import EdiModal from "../Modals/SignModal";
import Spinner from "../Modals/SpinnerModal";

import styled from "styled-components";

const Profile = styled.div`
  width: 80%;
  padding: 0 10%;
  height: 300px;
  background: white;
  border-radius: 5px;
`;

const ImageContainer = styled.div`
  width: 30%;
  height: 100%;
  float: left;
  text-align: center;
  @media (max-width: 768px) {
    width: 100%;
    height: 100px;
  }
`;
const Image = styled.img`
  width: 150px;
  height: 150px;
  background: white;
  border-radius: 100%;
  margin-top: 70px;
  @media (max-width: 768px) {
    width: 80px;
    height: 80px;
  }
`;
const ProfileDetails = styled.div`
  width: 69%;
  height: 100%;
  float: right;
  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
  }
`;
const ProfileName = styled.h1`
  margin: 0;
  padding: 100px 0 5px 0;
  @media (max-width: 768px) {
    padding: 60px 0 5px 0;
  }
`;
const Location = styled.p`
  margin: 0;
  padding: 0;
  font-weight: 500;
`;
const PinImage = styled.img`
  width: 17px;
  height: 17px;
`;
const ChangePassword = styled.div`
  width: 50%;
  height: auto;
  margin: 30px 0 0 23%;
  background: white;
  padding: 20px;
  border-radius: 5px;
`;
const Input = styled.input`
  width: 95%;
  padding: 15px 3%;
  border: 1px solid #ccc;
  display: block;
  margin: 10px 0;
  border-radius: 5px;
  outline: none;
  font-size: 1em;
`;
const Button = styled.button`
  padding: 12px 30px;
  background: #b92d47;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  outline: none;
  margin: 10px 0;
`;
const ChangeTitle = styled.p`
  font-size: 1.2em;
  margin: 0;
  padding: 0;
`;
const EditButton = styled.button`
  padding: 8px 30px;
  border: 1px solid #eee;
  color: #b92d47;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  outline: none;
  margin: 10px 0;
`;

const Button2 = styled.button`
  width: 100%;
  padding: 13px 0;
  margin: 10px 0 20px 0;
  border: none;
  color: white;
  outline: none;
  background: #276fb7;
  border-radius: 5px;
  font-size: 1em;
  cursor: pointer;
`;
const Title = styled.h2`
  margin: 0;
  padding: 0 0 20px 0;
  color: #276fb7;
  font-weight: 500;
`;
function UserProfile(props) {
  const [user, setUser] = useState(null);
  const [complete, setComplete] = useState(false);
  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const [updateModal, setUpdateModal] = useState(false);
  const [spinner, setSpinner] = useState(false);

  const nameChangeHandler = (e) => {
    setName(e.target.value);
  };

  const locationChangeHandler = (e) => {
    setLocation(e.target.value);
  };
  const updateHandler = async () => {
    try {
      if (user.user_name != name || user.location != location) {
        setSpinner(true);
        await axios
          .post(server, {
            query: `
                      mutation{
                        updateUser(userId:"${props.utils.userId}", name:"${name}", location:"${location}"){
                            _id
                            user_name
                            email
                            phone
                            location
                            newNotification
                        } 
                    }
                    `,
          })
          .then((res) => {
            setUser(res.data.data.updateUser);
            props.setUser(res.data.data.updateUser);
            setUpdateModal(false);
            setSpinner(false);
          });
      } else {
        setUpdateModal(true);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const updateModalHandler = () => {
    setUpdateModal(!updateModal);
  };
  const fetchUser = async () => {
    try {
      await axios
        .post(server, {
          query: `
                 query{
                  user(token:"${localStorage.TOKEN}"){
                    _id
                    user_name
                    location
                  }
                 }
              `,
        })
        .then((res) => {
          const user = res.data.data.user;
          setUser(user);
          setName(user.user_name);
          setLocation(user.location);
          setComplete(true);
          //props.setUser(user);
          //setNewNoti(user.newNotification);
          // if (res.data.errors.length === 0) {
          //   if (user.data && user.data !== null) {
          //     props.setUser(user.data.data.user);
          //   }
          // }
        });
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);
  return (
    <div>
      <Spinner show={spinner} />
      <EdiModal show={updateModal} closeModal={updateModalHandler}>
        <div style={{ padding: "2% 0", width: "90%" }}>
          {/* <div>
              <SignImg src={SignIllustration}/> 
            </div> */}
          <Title>Update profile</Title>
          <Input
            name={name}
            value={name}
            onChange={nameChangeHandler}
            type="text"
            placeholder="Name"
          />
          <Input
            name={location}
            value={location}
            onChange={locationChangeHandler}
            type="text"
            placeholder="Location"
          />

          <div>
            <Button2 onClick={updateHandler}>Update</Button2>
          </div>
        </div>
      </EdiModal>
      {complete ? (
        <Profile>
          <ImageContainer>
            <Image src={Virat} alt="profile-image" />
          </ImageContainer>
          <ProfileDetails>
            <ProfileName>{user.user_name}</ProfileName>
            {user.location ? (
              <Location>
                <PinImage src={Pin} alt="location" />
                {user.location}
              </Location>
            ) : null}
            <EditButton onClick={updateModalHandler}>Edit profile</EditButton>
          </ProfileDetails>
        </Profile>
      ) : (
        <p>Loading...</p>
      )}
      {/* <ChangePassword>
             <ChangeTitle>Change password</ChangeTitle>
             <Input type="password" placeholder="Old password"/>
             <Input type="password" placeholder="New password"/>
            <div style={{textAlign:"center"}}>
              <Button>Change Password</Button>
            </div>
         </ChangePassword> */}
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    cart: state.utils.cart,
    name: state.utils.name,
    auth: state.utils.auth,
    utils: state.utils,
    checkout: state.utils.checkout,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (user) => {
      dispatch({
        type: actionTypes.AUTH_USER,
        user,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);
